import React from "react";

const PaginationPage = (props) => {
    return (
        <li className={props.isActive ? "active" : ""}>
            <a onClick={() => props.onPageClick(props.pageName)} aria-label={props.pageName}>
                <span>{props.pageName}</span>
            </a>
        </li>
    )
}

export default PaginationPage;